import { getSlots, getUnslottedChildren } from "@/mds/utils/slots";
import {
  StyledSection,
  StyledSectionHeader,
  StyledSectionHeaderText,
  StyledSectionSeparator,
  StyledSectionSeparatorLine,
} from "./section.style";
import { MdsSectionProps, MDSSectionSlotName } from "./section.types";
import { MDSTextVariant } from "@/mds/components/text";

export const MDSSection = ({ title, children }: MdsSectionProps) => {
  const headerRightAddon = getSlots(children, MDSSectionSlotName.HeaderRightAddon);
  const content = getUnslottedChildren(children);

  return (
    <StyledSection>
      <StyledSectionHeader>
        {title && (
          <StyledSectionHeaderText variant={MDSTextVariant.HeaderS}>
            {title}
          </StyledSectionHeaderText>
        )}
        {headerRightAddon}
      </StyledSectionHeader>

      <StyledSectionSeparator>
        <StyledSectionSeparatorLine />
      </StyledSectionSeparator>
      {content}
    </StyledSection>
  );
};
